import React from 'react';
import { stats } from '../mock';

export default function Stats() {
  return (
    <section className="relative py-16 lg:py-20 border-y border-[#e8e4d8] bg-[#0b0f0d]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
          {stats.map((s, i) => (
            <div key={i} className="text-center md:border-r md:last:border-r-0 border-white/10 py-2">
              <div className="font-display text-4xl lg:text-5xl font-semibold text-[#ea580c]">{s.value}</div>
              <div className="mt-2 text-xs md:text-sm text-white/70 uppercase tracking-[0.15em]">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
